import React from 'react';
import { Chip, Grid, Paper, withStyles } from '@material-ui/core';
import BoothDialog from './BoothDialog';
import axios from 'axios';
import { BOOTH_API_URL, EVENT_FOLDER, EVENT_ID, getUserID } from '../constants';
import './BoothItem.css';

// import { MdOutlineCheckCircleOutline } from 'react-icons/md';
// import { GiStamper } from 'react-icons/gi';

const styles = (theme) => ({
  card: {
    transition: '0.3s',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    float: 'left',
    height: '127px',
    width: '127px',
    padding: '5px',
    margin: '7px',
    position: 'relative',
    borderRadius: '10px',
    boxShadow: 'inset 0 0 34.2px 3.8px rgba(177, 177, 177, 0.1)',
    backgroundColor: '#f4f4f4',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },

    '&:hover': {
      '& $cardOverlay': {
        display: 'block',
      },
    },
  },

  //booth card visable
  cardGridMob: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  //booth card container
  cardMob: {
    display: 'flex',
    borderRadius: '5px',
    margin: '5px 0 ',
    cursor: 'pointer',
    // transition: '0.3s',
    // flexDirection: 'column',
    // alignItems: 'center',
    // float: 'left',
    // maxHeight: '100px',
    // width: '100%',
    // position: 'relative',
    // backgroundColor: '#f4f4f4',
  },

  boothGrid: {
    height: '150px',
    width: '150px',
  },
  // imgCard: {
  //   width: '85%',
  // },
  imgCardMob: {
    width: '95%',
    height: 'auto',
  },
  abArea: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    display: 'flex',
  },
  boothNm: {
    color: '#f4f4f4',
    paddingLeft: '5px',
  },
  cardOverlay: {
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    transition: '0.3s',
    flexDirection: 'column',
    alignItems: 'center',
    float: 'left',
    height: '127px',
    width: '127px',
    borderRadius: '10px',
    padding: '5px',
    position: 'absolute',
    cursor: 'pointer',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  webBooth: {
    display: 'block',
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class BoothItem extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      boothDialog: false,
      selectedData: {},
    };
    this.clickDetail = this.clickDetail.bind(this);
    this.visitUpdate = this.visitUpdate.bind(this);
  }
  componentDidMount() {
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      if (!sessionStorage.getItem('_in_user_')) {
        this.props.history.push('signin');
      }
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }
  }
  openBoothDialog = (value, data) => {
    this.visitUpdate(data);
    if (data.grade !== 'standard') {
      if (data.type === '2') window.open(data.homepage, `win_${data.id}`);
      else {
        this.setState({ boothDialog: true, selectedData: value });
      }
    }
  };

  // closeBoothDialog = (event) => {
  //   this.setState({ boothDialog: false });
  // };

  visitUpdate(data) {
    setTimeout(() => {
      let param = {
        userid: getUserID(true),
        boothId: data.id,
        boothName: data.name,
        username: sessionStorage.getItem('_in_name'),
        position: sessionStorage.getItem('_in_pos'),
        evt: EVENT_ID,
      };

      axios.post(`${BOOTH_API_URL}/booth/stamp`, param).then((response) => {
        this.props.emitBoothVisit();
      });

      // for Log
      axios.post(`${BOOTH_API_URL}/booth/visit`, param).then((response) => {});

      // for Count
      let isFirst = false;
      if (!sessionStorage.getItem('firstEnterBooth_' + data.id)) {
        isFirst = true;
        sessionStorage.setItem('firstEnterBooth_' + data.id, true);
      }
      param['isFirst'] = isFirst;
      axios.post(`${BOOTH_API_URL}/booth/view`, param).then((response) => {});
    }, 100);
  }

  clickDetail(data) {
    if (data.grade === 'standard') {
    } else {
      this.visitUpdate(data);
      if (data.type === '2') window.open(data.homepage, `win_${data.id}`);
      else {
        let win = window.open(`/#/boothBasic/${data.id}`, `win_${data.id}`);
        win.document.title = 'KSC 2022 Spring Conference - Exhibition';
      }
    }
    // const today = new Date();
    // const limitDay = new Date('2020-08-29 23:59:50');

    // if (today > limitDay) {
    //   console.log('event finish');
    // } else {
    // if (this.state.myCount >= 37) {
    //   if (!this.state.snack3Show && this.state.eventSuccess) {
    //     this.setState({ snack1Open: false, snack2Open: false, snack3Open: true, snack3Show: true });
    //   }
    //   // this.checkEvent();
    // } else {
  }

  render() {
    const { classes } = this.props;
    const data = this.props.satellite;

    return (
      <React.Fragment>
        {/* 웹부스 */}
        {/* <div className={classes.webBooth}>
          <div
            className={this.props.satellite.id}
            style={{
              position: 'absolute',
              cursor: 'pointer',
              backgroundColor: 'transparent',
            }}
            onClick={() => this.clickDetail(data)}
          >
            <Grid container justifyContent="center" alignItems="center" item xs={12} style={{ height: '100%' }}>
              {this.props.satellite.visit && (
                <MdOutlineCheckCircleOutline size={20} style={{ color: '#55B9C3', position: 'absolute', top: 0, right: 0 }} />
              )}
              <img
                src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
                alt={''}
                style={{ width: '90%' }}
              />
            </Grid>
          </div>
        </div> */}

        {/* **custom 웹부스 등급별 영역안에서 배열 */}
        <div className={classes.webBooth}>
          <Grid
            container
            style={{
              cursor: this.props.satellite.grade ? '' : 'pointer',
            }}
            onClick={() => this.clickDetail(data)}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              item
              xs={12}
              style={{ height: '100%', position: 'relative' }}
            >
              {/* {this.props.satellite.grade !== 'standard' && this.props.satellite.visit && (
                <GiStamper
                  size={15}
                  style={{
                    color: '#de3e36',
                    position: 'absolute',
                    top: 0,
                    right: this.props.satellite && this.props.satellite.grade === 'diamond' ? 0 : '8%',
                    backgroundColor: 'transparent',
                    border: '1px solid #de3e36',
                    borderRadius: '100%',
                  }}
                />
              )} */}
              {/* <img
                src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
                alt={''}
                className={`${this.props.satellite.grade}_item`}
                // style={{ backgroundColor: '#fff' }}
              /> */}

              {this.props.satellite.logo && this.props.satellite.id === 'evt113_999' ? (
                <img
                  className={`${this.props.satellite.grade}_item`}
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/logo_custom.gif`}
                  alt={'img'}
                />
              ) : (
                <img
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
                  alt={''}
                  className={`${this.props.satellite.grade}_item`}
                  // style={{ backgroundColor: '#fff' }}
                />
              )}
            </Grid>
          </Grid>
        </div>

        {/* 모바일 부스  */}
        <Grid container justifyContent="center" className={classes.cardGridMob}>
          <Paper
            elevation={1}
            onClick={() => {
              this.openBoothDialog(this.props.satellite, data);
            }}
            // onClick={() => this.visitUpdate(data)}
            className={classes.cardMob}
            style={{ width: '96%' }}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              style={{ height: this.state.matches ? 'auto' : '100%' }}
            >
              {this.props.satellite.visit && (
                <Chip label="visit" color={'primary'} style={{ position: 'absolute', top: 0, right: 0, height: 25 }} />
              )}

              {this.props.satellite.logo && this.props.satellite.id === 'evt113_999' ? (
                <img
                  className={classes.imgCardMob}
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/logo_custom.gif`}
                  alt={'img'}
                />
              ) : (
                <img
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
                  alt={''}
                  className={classes.imgCardMob}
                  // style={{ backgroundColor: '#fff' }}
                />
              )}

              {/* {this.props.satellite.logo && (
                <img
                  className={classes.imgCardMob}
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
                  alt={'img'}
                />
              )} */}
            </Grid>
          </Paper>
        </Grid>

        <BoothDialog
          data={this.state.selectedData}
          id={this.state.selectedData.id}
          name={this.state.selectedData.name}
          homepage={this.state.selectedData.homepage}
          visit={this.state.selectedData.visit}
          logo={this.state.selectedData.logo}
          logoalt={this.state.selectedData.logoalt}
          mp4={this.state.selectedData.mp4}
          datas={this.props.satellites}
          emitBoothVisit={this.props.emitBoothVisit}
          open={this.state.boothDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ boothDialog: false });
            }
          }}

          // onClose={this.closeBoothDialog}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BoothItem);
